import { ElementType } from "react"
import { lighten, MenuItemTypeMap, MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps, styled } from "@mui/material"

export type MenuItemProps<D extends ElementType = MenuItemTypeMap["defaultComponent"], P = {}> = Omit<MuiMenuItemProps<D, P>, "value"> & {
    value?: any
}

const StyledMenuItem = styled(MuiMenuItem)(({ theme }) => ({
    "&.Mui-selected": {
        backgroundColor: lighten(theme.palette.primary.main, 0.8),
        "&:hover": {
            backgroundColor: lighten(theme.palette.primary.main, 0.75),
        },
    },
    "&:hover": {
        backgroundColor: theme.palette.grey[200],
    },
}))

export function MenuItem<T extends ElementType = MenuItemTypeMap["defaultComponent"]>(props: MenuItemProps<T>) {
    const { children } = props

    return <StyledMenuItem {...props}>{children}</StyledMenuItem>
}
